import type { DidacticModel } from '../types/conceptMap';
import type { LayoutFunction } from './types';
import { hierarchyLayout } from './hierarchyLayout';
import { definitionLayout } from './definitionLayout';
import { contrastLayout } from './contrastLayout';

const LAYOUT_MAP: Record<DidacticModel, LayoutFunction> = {
  hierarchy: hierarchyLayout,
  definition: definitionLayout,
  contrast: contrastLayout,
};

/**
 * Select layout function based on didactic model type.
 * Falls back to hierarchy if model is unknown.
 */
export function getLayout(model: DidacticModel): LayoutFunction {
  return LAYOUT_MAP[model] ?? hierarchyLayout;
}

export type { LayoutFunction, CanvasSize, PositionedNode } from './types';
